import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2" }, "Pro", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-7"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_10 = { class: "menu-item px-5" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_12 = {
  class: "menu-item px-5",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_13 = { class: "menu-title position-relative" }
const _hoisted_14 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_15 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_16 = { class: "menu-item px-3" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "media/flags/united-states.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" English ")
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "media/flags/spain.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Spanish ")
const _hoisted_22 = { class: "menu-item px-5 my-1" }
const _hoisted_23 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            alt: "Logo",
            src: `media/avatars/${_ctx.user.uid}.jpg`
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.user.email) + " ", 1),
            _hoisted_7
          ]),
          _hoisted_8
        ])
      ])
    ]),
    _hoisted_9,
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_router_link, {
        to: "/account",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.translate("myprofile")), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_11,
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createVNode("span", _hoisted_13, [
            _createTextVNode(_toDisplayString(_ctx.translate ("language")) + " ", 1),
            _createVNode("span", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.currentLangugeLocale.name) + " ", 1),
              _createVNode("img", {
                class: "w-15px h-15px rounded-1 ms-2",
                src: _ctx.currentLangugeLocale.flag,
                alt: "metronic"
              }, null, 8, ["src"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _createVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('en'))),
            href: "#",
            class: ["menu-link d-flex px-5", { active: _ctx.currentLanguage('en') }]
          }, [
            _hoisted_17,
            _hoisted_18
          ], 2)
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLang('es'))),
            href: "#",
            class: ["menu-link d-flex px-5", { active: _ctx.currentLanguage('es') }]
          }, [
            _hoisted_20,
            _hoisted_21
          ], 2)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_22, [
      _createVNode(_component_router_link, {
        to: "/account/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.translate("accountsettings")), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_23, [
      _createVNode("a", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, _toDisplayString(_ctx.translate("signout")), 1)
    ])
  ]))
}